
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sleet': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M59.943 41.642c-.696 0-1.369.092-2.033.205-2.736-4.892-7.961-8.203-13.965-8.203-8.835 0-15.998 7.162-15.998 15.997 0 5.992 3.3 11.207 8.177 13.947a6.936 6.936 0 0 1 1.873-3.445l.057-.057c-3.644-2.061-6.106-5.963-6.106-10.445 0-6.626 5.372-11.998 11.998-11.998 5.691 0 10.433 3.974 11.665 9.29a7.939 7.939 0 0 1 4.333-1.291 7.999 7.999 0 0 1 7.999 7.999c0 3.443-2.182 6.371-5.235 7.498a6.963 6.963 0 0 1 1.222 3.807c4.665-1.645 8.014-6.078 8.014-11.305-.002-6.627-5.374-11.999-12.001-11.999zM42.945 60.85l-2.121 2.121a3 3 0 1 0 4.242 0l-2.121-2.121zm7 7.998l-2.121 2.121a2.998 2.998 0 1 0 4.241 4.242 2.998 2.998 0 0 0 0-4.242l-2.12-2.121zm6.999-7.998l-2.121 2.121a2.998 2.998 0 0 0 0 4.242 2.998 2.998 0 1 0 4.242-4.242l-2.121-2.121z"/>'
  }
})
